import { ButtonStyled, Colors, GridBreakpointsMediaDown } from '@dbi-tools/ui-kit';
import styled from 'styled-components';

export const FooterStyled = styled('div')`
  background-color: ${Colors.white};
  padding: 14px 0 30px;
  position: fixed;
  z-index: 10;
  bottom: 0;
  width: 100%;
  border-top: 1px solid ${Colors.secondaryLight};

  ${ButtonStyled} {
    min-width: 144px;

    ${GridBreakpointsMediaDown.xs} {
      width: 100%;
      min-width: 100%;
    }
  }
`;

export const FooterTextStyled = styled('div')`
  display: flex;
  align-items: center;
  min-height: 48px;
`;
